import { useEffect, useRef, useState } from "react";
import { getVideoCallContact } from "../../../../../util/APIUtils";


export const usePictureViewerHook = (props) => {
    const initialContactDetails = {
        firstName: '',
        lastName: ''
    };
    const modalRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const [videoContactDetails, setVideoContactDetails] = useState(initialContactDetails);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            getContactDetails();
        }
    }, [isOpen]);

    const getContactDetails = async () => {
        try {
            setIsLoading(true);
            const response = await getVideoCallContact(props.details.contactId);
            setVideoContactDetails(response);
        } catch (e) {
            console.log(e);
        } finally {}
        setIsLoading(false);
    };

    const toggleModal = () => {
        setVideoContactDetails(initialContactDetails);
        setIsOpen(!isOpen);
        modalRef.current.toggleModal();
    };

    return { videoContactDetails, isLoading, modalRef, toggleModal };
};